import { render } from "./ThemeButton.vue?vue&type=template&id=574cdf6e"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__